import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import axios from 'axios';

import { showAPIErrorToast, showErrorToast, showLunaErrorToast } from '@vlabs/shared/components/error-toasts';

function handleError(error) {
  if (error instanceof LunaError) {
    showLunaErrorToast(error);
  } else if (axios.isAxiosError(error)) {
    showAPIErrorToast(error);
  } else if (error instanceof Error) {
    showErrorToast(error);
  }
}

export const registerErrorHandlers = () => {
  window.addEventListener('error', (event) => {
    console.error(event);
    handleError(event.reason);
    event.preventDefault();
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error(event);
    handleError(event.reason);
    event.preventDefault();
  });
};
